export default __webpack_public_path__ + "static/media/20200926_145544.e2097ab6.jpg";